/** Working name — change it here (and in index.html's <title>) when the real name is picked. */
export const APP_NAME = 'Grams';

/**
 * Where the About page sends suggestions.
 * Deploy's EMAIL_FROM is `noreply@grams.pointer.bet` — a send-only address, not an inbox.
 * Nothing in the repo is a support or feedback address, so this is the founder (also ADMIN_EMAILS).
 */
export const FOUNDER_EMAIL = 'izerop@gmail.com';
